// extracted by mini-css-extract-plugin
export default {"tabbyContainer":"styles__tabbyContainer___F1TFD","iconPadding":"styles__iconPadding___oMTLt"};